import { Nav } from "../components/Nav";
import { Squiggle } from "../components/Squiggle";
import { WelcomeModal } from "../components/WelcomeModal";
import { Hero } from "../components/sections/Hero";
import { CampaignMarquee } from "../components/sections/CampaignMarquee";
import { Problems } from "../components/sections/Problems";
import { Shift } from "../components/sections/Shift";
import { CreateWithUs } from "../components/sections/CreateWithUs";
import { Footer } from "../components/sections/Footer";
import { useSite } from "@/lib/site";

const SECTION_COMPONENTS = {
  hero: Hero,
  campaign: CampaignMarquee,
  problems: Problems,
  shift: Shift,
  services: CreateWithUs,
  booking: Footer, // booking app lives inside Footer
  footer: null,    // footer renders via booking slot
};

export default function Landing() {
  const { sections } = useSite();
  const order = sections && sections.length > 0 ? sections : ["hero", "campaign", "problems", "shift", "services", "booking", "footer"];
  // de-dupe: booking renders the Footer (which contains booking); footer slot is merged
  const rendered = [];
  order.forEach((id) => {
    if (id === "booking" || id === "footer") {
      if (!rendered.includes("footer-block")) rendered.push("footer-block");
    } else if (SECTION_COMPONENTS[id]) {
      rendered.push(id);
    }
  });
  if (!rendered.includes("footer-block")) rendered.push("footer-block");

  return (
    <div className="relative overflow-hidden" data-testid="landing-page">
      <WelcomeModal />
      <div className="page-gradient absolute inset-0 -z-20" aria-hidden />
      <Squiggle className="absolute inset-0 -z-10 h-full w-full" />
      <Nav />
      <main className="relative z-0">
        {rendered.map((id) => {
          if (id === "footer-block") return <Footer key="footer-block" />;
          const C = SECTION_COMPONENTS[id];
          return C ? <C key={id} /> : null;
        })}
      </main>
    </div>
  );
}
